import { useCallback, useEffect, useRef } from 'react';
import "./BarChart.scss";
import Chart from 'chart.js/auto';
import { withLocale } from '../../l10n';

const BarChart = ({ labels, data, options, lang, dataLabel }) => {

  // ===== 1. REFS =====
  const canvasRef = useRef(null);
  const chartRef = useRef(null);

  // ===== 2. FUNCIONES PRINCIPALES =====
  const createChart = useCallback(() => {
    const ctx = canvasRef.current;
    if (!ctx) return;

    chartRef.current = new Chart(ctx, {
      type: 'bar',
      data: {
        labels: labels,
        datasets: [{
          label: lang.handle(dataLabel),
          data: data,
          backgroundColor: 'rgba(54, 162, 235, 0.5)',
          borderColor: 'rgba(54, 162, 235, 0.1)',
          borderWidth: 1
        }]
      },
      options: options
    });
  }, [labels, data, options, lang, dataLabel]);

  const updateChart = useCallback(() => {
    chartRef.current.data.labels = labels;
    chartRef.current.data.datasets[0].data = data;
    chartRef.current.data.datasets[0].label = lang.handle(dataLabel);

    chartRef.current.options = { ...options };

    chartRef.current.update();
  }, [labels, data, options, lang, dataLabel]);

  // ===== 3. EFFECTS =====
  useEffect(() => {
    if (!chartRef.current) {
      createChart();
    } else {
      updateChart();
    }
  }, [createChart, updateChart]);

  useEffect(() => {
    return () => {
      if (chartRef.current) {
        chartRef.current.destroy();
        chartRef.current = null;
      }
    };
  }, []);

  // ===== 4. RENDER =====
  return <canvas ref={canvasRef} />;
};

export default withLocale(BarChart);
